import { Routes } from '@angular/router';
import { roleGuard } from './guards/role-guard.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'welcome',
    pathMatch: 'full',
  },
  {
    path: 'terms/:termId/availability',
    loadComponent: () =>
      import('./pages/term-availability/term-availability.page').then(
        (c) => c.TermAvailabilityPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator', 'SiteLeader', 'CustomerAccountManager'] },
  },
  {
    path: 'terms/:termId/slots',
    loadComponent: () =>
      import('./pages/slots/slots.page').then((c) => c.SlotsPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator', 'SiteLeader', 'CustomerAccountManager'] },
  },
  {
    path: 'activities/:activityId',
    loadComponent: () =>
      import('./pages/activity/activity.page').then((c) => c.ActivityPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator', 'CurriculumDesigner'] },
  },
  {
    path: 'alternateStudentAvailabilities/:alternateStudentId',
    loadComponent: () =>
      import('./pages/alternate-student-availability/alternate-student-availability.page').then(
        (c) => c.AlternateStudentAvailabilityPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator', 'SiteLeader', 'CustomerAccountManager'] },
  },
  {
    path: 'alternateStudentNotAvailabileDays/:alternateStudentId',
    loadComponent: () =>
      import('./pages/alternate-student-not-availabile-days/alternate-student-not-availabile-days.page').then(
        (c) => c.AlternateStudentNotAvailabileDaysPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator', 'SiteLeader', 'CustomerAccountManager'] },
  },
  {
    path: 'curriculums/:curriculumId',
    loadComponent: () =>
      import('./pages/curriculum/curriculum.page').then(
        (c) => c.CurriculumPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator', 'CurriculumDesigner'] },
  },
  {
    path: 'organizationDetails/:organizationId',
    loadComponent: () =>
      import('./pages/organization-details/organization-details.page').then(
        (c) => c.OrganizationDetailsPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator', 'SiteLeader', 'CustomerAccountManager'] },
  },
  {
    path: 'organizations/:organizationId',
    loadComponent: () =>
      import('./pages/organization/organization.page').then(
        (c) => c.OrganizationPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator', 'SiteLeader', 'CustomerAccountManager'] },
  },
  {
    path: 'resourceCategories/:resourceCategoryId',
    loadComponent: () =>
      import('./pages/resource-category/resource-category.page').then(
        (c) => c.ResourceCategoryPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator', 'CurriculumDesigner'] },
  },
  {
    path: 'resources/:resourceId',
    loadComponent: () =>
      import('./pages/resource/resource.page').then((c) => c.ResourcePage),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator', 'CurriculumDesigner'] },
  },
  {
    path: 'resourceSets/:resourceSetId',
    loadComponent: () =>
      import('./pages/resource-set/resource-set.page').then(
        (c) => c.ResourceSetPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator', 'CurriculumDesigner'] },
  },
  {
    path: 'selectedStudentNotAvailabileDays/:selectedStudentId',
    loadComponent: () =>
      import('./pages/selected-student-not-availabile-days/selected-student-not-availabile-days.page').then(
        (c) => c.SelectedStudentNotAvailabileDaysPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator', 'SiteLeader', 'CustomerAccountManager'] },
  },
  {
    path: 'selectedStudentSchedule/:selectedStudentId',
    loadComponent: () =>
      import('./pages/selected-student-schedule/selected-student-schedule.page').then(
        (c) => c.SelectedStudentSchedulePage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator', 'SiteLeader', 'CustomerAccountManager'] },
  },
  {
    path: 'sessions/:sessionId',
    loadComponent: () =>
      import('./pages/session/session.page').then((c) => c.SessionPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: {
      roles: ['Administrator', 'SiteLeader', 'Tutor', 'CustomerAccountManager'],
    },
  },
  {
    path: 'studentOnlineSession/:studentId',
    loadComponent: () =>
      import('./pages/student-online-session/student-online-session.page').then(
        (c) => c.StudentOnlineSessionPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator', 'Student'] },
  },
  {
    path: 'students/:studentId',
    loadComponent: () =>
      import('./pages/student/student.page').then((c) => c.StudentPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator', 'SiteLeader', 'CustomerAccountManager'] },
  },
  {
    path: 'terms/:termId',
    loadComponent: () =>
      import('./pages/term/term.page').then((c) => c.TermPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator', 'SiteLeader', 'CustomerAccountManager'] },
  },
  {
    path: 'testArticles/:testArticleId',
    loadComponent: () =>
      import('./pages/test-article/test-article.page').then(
        (c) => c.TestArticlePage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator', 'CurriculumDesigner'] },
  },
  {
    path: 'testResults/:testResultId',
    loadComponent: () =>
      import('./pages/test-result/test-result.page').then(
        (c) => c.TestResultPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator', 'SiteLeader', 'CustomerAccountManager'] },
  },
  {
    path: 'tutorAvailability/:termTutorId',
    loadComponent: () =>
      import('./pages/tutor-availability/tutor-availability.page').then(
        (c) => c.TutorAvailabilityPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator', 'SiteLeader', 'CustomerAccountManager'] },
  },
  {
    path: 'tutorOnlineSession/:sessionId',
    loadComponent: () =>
      import('./pages/tutor-online-session/tutor-online-session.page').then(
        (c) => c.TutorOnlineSessionPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator', 'SiteLeader', 'Tutor'] },
  },
  {
    path: 'tutors/:tutorId',
    loadComponent: () =>
      import('./pages/tutor/tutor.page').then((c) => c.TutorPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator', 'SiteLeader', 'CustomerAccountManager'] },
  },
  {
    path: 'tutorSchedule/:termTutorId',
    loadComponent: () =>
      import('./pages/tutor-schedule/tutor-schedule.page').then(
        (c) => c.TutorSchedulePage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator', 'SiteLeader', 'CustomerAccountManager'] },
  },
  {
    path: 'about',
    loadComponent: () =>
      import('./pages/about/about.page').then((c) => c.AboutPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator'] },
  },
  {
    path: 'attendance',
    loadComponent: () =>
      import('./pages/attendance/attendance.page').then(
        (c) => c.AttendancePage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: {
      roles: ['Administrator', 'SiteLeader', 'Tutor', 'CustomerAccountManager'],
    },
  },
  {
    path: 'curriculums',
    loadComponent: () =>
      import('./pages/curriculums/curriculums.page').then(
        (c) => c.CurriculumsPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator', 'CurriculumDesigner'] },
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login/login.page').then((c) => c.LoginPage),
    pathMatch: 'full',
  },
  {
    path: 'not-authorized',
    loadComponent: () =>
      import('./pages/not-authorized/not-authorized.page').then(
        (c) => c.NotAuthorizedPage,
      ),
    pathMatch: 'full',
  },
  {
    path: 'organizationProperties',
    loadComponent: () =>
      import('./pages/organization-properties/organization-properties.page').then(
        (c) => c.OrganizationPropertiesPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator'] },
  },
  {
    path: 'organizations',
    loadComponent: () =>
      import('./pages/organizations/organizations.page').then(
        (c) => c.OrganizationsPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator', 'SiteLeader', 'CustomerAccountManager'] },
  },
  {
    path: 'resources',
    loadComponent: () =>
      import('./pages/resources/resources.page').then((c) => c.ResourcesPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator', 'CurriculumDesigner'] },
  },
  {
    path: 'resourceSets',
    loadComponent: () =>
      import('./pages/resource-sets/resource-sets.page').then(
        (c) => c.ResourceSetsPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator', 'CurriculumDesigner'] },
  },
  {
    path: 'switch-user',
    loadComponent: () =>
      import('./pages/switch-user/switch-user.page').then(
        (c) => c.SwitchUserPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
  {
    path: 'testArticles',
    loadComponent: () =>
      import('./pages/test-articles/test-articles.page').then(
        (c) => c.TestArticlesPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator', 'CurriculumDesigner'] },
  },
  {
    path: 'tutors',
    loadComponent: () =>
      import('./pages/tutors/tutors.page').then((c) => c.TutorsPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator', 'SiteLeader', 'CustomerAccountManager'] },
  },
  {
    path: 'user-activity',
    loadComponent: () =>
      import('./pages/user-activity/user-activity.page').then(
        (c) => c.UserActivityPage,
      ),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator'] },
  },
  {
    path: 'userRoles',
    loadComponent: () =>
      import('./pages/user-roles/user-roles.page').then((c) => c.UserRolesPage),
    pathMatch: 'full',
    canActivate: [roleGuard],
    data: { roles: ['Administrator'] },
  },
  {
    path: 'welcome',
    loadComponent: () =>
      import('./pages/welcome/welcome.page').then((c) => c.WelcomePage),
    pathMatch: 'full',
    canActivate: [roleGuard],
  },
];
